import { TOrgHeirachy } from '@monorepo/types';
import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { PIPELINE_ORG_HEIRARCHY } from './org-heirarchy.pipeline';
import { TEnhancedOrgHeirachyModel, TOrgHeirachyModel } from './org-heirarchy.types';
import { UTIL_ORG_HEIRARCHY } from './org-heirarchy.util';

export const ORG_HEIRARCHY_MODEL = {
  createEnhancedModel: (
    isMinimized = true,
    orgTree: TOrgHeirachy,
    filteredOrgTree?: TOrgHeirachy,
  ): TEnhancedOrgHeirachyModel => {
    const rec = (
      nodeTree: TOrgHeirachy['values'],
      filteredOrgTreeNode?: TOrgHeirachy['values'],
    ): TOrgHeirachyModel['values'] => {
      const result = nodeTree.map((node) => {
        //Note: working on assumption that same level doesn't have duplicate values
        const selectedFilteredNode = filteredOrgTreeNode?.find((v) => {
          if (v.id && node.id) {
            return v.id === node.id;
          } else {
            return v.value === node.value;
          }
        });
        const children = node.children?.nodes
          ? {
              ...node.children,
              nodes: rec(node.children?.nodes, selectedFilteredNode?.children?.nodes || []),
            }
          : undefined;
        return {
          ...node,
          children,
          enhancedNodeInfo: {
            id: node.id ? node.id : uuidv4(),
            isMinimized,
            isSelected: !!selectedFilteredNode,
          },
        };
      });
      return result;
    };
    return {
      orgTreeModel: {
        ...orgTree,
        values: rec(orgTree.values, filteredOrgTree?.values),
      },
    };
  },

  toggleNode: (
    treeNode: TOrgHeirachyModel['values'][number],
    enhancedTreeModel: TEnhancedOrgHeirachyModel,
  ): TEnhancedOrgHeirachyModel => {
    return PIPELINE_ORG_HEIRARCHY.toggleNode({
      ...enhancedTreeModel,
      toggleNode: treeNode,
    });
  },

  selectNode: (
    treeNode: TOrgHeirachyModel['values'][number],
    enhancedTreeModel: TEnhancedOrgHeirachyModel,
    hasMultiSelectSupport?: boolean,
  ): TEnhancedOrgHeirachyModel => {
    const updatedTreeModel = {
      ...enhancedTreeModel,
      selectedNode: {
        data: {
          ...treeNode,
          enhancedNodeInfo: {
            ...treeNode.enhancedNodeInfo,
            isSelected: !treeNode.enhancedNodeInfo.isSelected,
          },
        },
        path: UTIL_ORG_HEIRARCHY.findNodePath(enhancedTreeModel.orgTreeModel.values, treeNode),
      },
    };
    return hasMultiSelectSupport
      ? PIPELINE_ORG_HEIRARCHY.selectNodeInMultiSelection(updatedTreeModel)
      : updatedTreeModel;
  },
};
